const ADM_PROFILE = "ADM_PROFILE"
const OPERATOR_PROFILE = "OPERATOR_PROFILE"

const checkProfile = ()=>{
    if(localStorage.email_logged){
        return ADM_PROFILE
    }

    return OPERATOR_PROFILE
}

const isAdmProfile = () =>{
    return checkProfile() === ADM_PROFILE
}
 
export { checkProfile, isAdmProfile }